module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/cases/a3_fc9a4acec7b0f568066f9819312b8bbd.png";